import styled from 'styled-components';
import { layout, media } from 'src/components/base';
import { Row } from '@prisjakt/ui/list/variants';

export const AppliedFilters = styled(Row)`
  margin-top: ${layout.measurements.spacing050};
  align-items: center;

  ${media.largeUp`
    margin-top: 0;
  `}
`;

export const AppliedFiltersTitle = styled.span`
  white-space: nowrap;
`;

export const AppliedFiltersWrapper = styled.div`
  margin: ${layout.measurements.spacing050};
`;
